<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table
    (detail)="onDetail($event)"
    [columns]="columns"
    [dataProviderParams]="params"
    [dataProvider]="compositionService"
    [title]="title"
  ></data-table>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="selected">
    <mat-card-content>
      <h4>{{selected}}</h4>
      <ng-container *ngIf="toDos && toDos > 0">
        <p>todo: {{toDos}} of {{dynamicContents.length}}</p>
        <p>Estimated duration: {{((toDos * 0.4) / 60).toFixed(2)}} min</p>
        <p>Progress: {{(elapsed / (1000 * 60)).toFixed(2)}} min</p>
      </ng-container>
      <p *ngIf="message">{{message}}</p>
      <div *ngIf="readyToExecute" class="button-right-container">
        <button (click)="execute()" class="ibexfusion-raised-button" mat-button>cleanUp</button>
      </div>
      <editor (changeContent)="onEditorChange($event)" *ngIf="!!dynamicContent"
                        [content]="dynamicContent.content.textContent"></editor>
    </mat-card-content>

  </mat-card>


</page-content>
